<div class="engagement-container">
    <button id="createReport" style="float: right;" (click)="openCreateModal()"> crear nuevo +</button>
    <table mat-table [dataSource]="params" aria-label="Tabla de engagement">
        <ng-container matColumnDef="Channel">
            <th mat-header-cell *matHeaderCellDef> Canal </th>
            <td mat-cell *matCellDef="let element">
                {{element.Channel}}
            </td>
        </ng-container>
        <ng-container matColumnDef="OBChannel">
            <th mat-header-cell *matHeaderCellDef>Canal de contratacion </th>
            <td mat-cell *matCellDef="let element">
                {{element.OBChannel}}
            </td>
        </ng-container>
        <ng-container matColumnDef="UrlOK">
            <th mat-header-cell *matHeaderCellDef>Url OK</th>
            <td mat-cell *matCellDef="let element">
                {{element.UrlOK}}
            </td>
        </ng-container>
        <ng-container matColumnDef="UrlKO">
            <th mat-header-cell *matHeaderCellDef>Url KO</th>
            <td mat-cell *matCellDef="let element">
                {{element.UrlKO}}
            </td>
        </ng-container>
        <ng-container matColumnDef="tyc">
            <th mat-header-cell *matHeaderCellDef>TyC</th>

            <td mat-cell *matCellDef="let element">
                {{mapTyc[element.tyc]}}
            </td>
            <!-- <td mat-cell *matCellDef="let element">
                <select style="min-width: 50px;margin-right: 10px;height: 22px;" [(ngModel)]="element.tyc" name="" id="">
                    <option value="1">Veracidad</option>
                    <option value="2">Veracidad y evaluación</option>
                </select>
            </td> -->
        </ng-container>

        <ng-container matColumnDef="button">
            <th mat-header-cell *matHeaderCellDef class="text-center"> Actualizar </th>
            <td class="text-center" mat-cell *matCellDef="let element">
                <img id="editReport" (click)="openCreateModal(element)" class="admin-icon" width="25px" style="cursor: pointer;" src="./assets/admin-icons/pencil.PNG"
                    alt="actualizar" title="Actualizar">

            </td>
        </ng-container>
        <ng-container matColumnDef="delete">
            <th mat-header-cell *matHeaderCellDef class="text-center"> Borrar </th>
            <td class="text-center" mat-cell *matCellDef="let element">
                <img id="deleteReport" (click)="openDeleteModal(element)" class="admin-icon" width="25px" style="cursor: pointer;" src="./assets/admin-icons/trash.PNG"
                    alt="Borrar" title="Borrar">

            </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <mat-paginator [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons></mat-paginator>
</div>
